import {ArticlePreview} from '../../core/article-preview';
import {DOM} from '../../core/dom';
import {Repo} from '../../core/repository';

window.addEventListener('load', () => {
  Repo.getArticles().onSuccess(displayArticles).onFailure(() => { displayArticles([]); });
})

function displayArticles(articles: Repo.Article[]): void {
  DOM.byId('articles').innerHTML = articles.length ? articles.map(a => ArticlePreview.create(a, 'h2')).join('') : '<h1>Към момента няма статии - опитайте по-късно</h1>';
}